import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

export const replaceLast = (find, replace, string) => {
  const lastIndex = string.lastIndexOf(find);

  if (lastIndex === -1) {
    return string;
  }

  const beginString = string.substring(0, lastIndex);
  const endString = string.substring(lastIndex + find.length);

  return beginString + replace + endString;
};

export const formatNumber = (val) => {
  if (!isNumber(val)) {
    return val;
  }
  // eslint-disable-next-line lodash/prefer-lodash-method
  let res = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  res = replaceLast(' ', ',', res);
  return res;
};

export const nl2br = (val) => {
  const str = isString(val) ? val : '';
  return str.replace(/\n/g, '<br>');
};
